import React from 'react';
import { Link } from 'react-router-dom';
import { useUiTheme } from 'framework/uiTheme';
import { BaseFieldLayoutType, LinkFieldLayoutProps, LinkFieldLayoutType } from '../../field';

const InternalLinkFieldLayout: LinkFieldLayoutType = ({ linkText, label, value }: LinkFieldLayoutProps) => {
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const displayedValue = value ? <Link to={value}>{linkText}</Link> : null;

  return <BaseFieldLayout label={label} value={displayedValue} />;
};

export default InternalLinkFieldLayout;
